"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiChoiceItem = exports.MultiChoiceValidator = void 0;
const validator_1 = require("./validator");
class MultiChoiceValidator extends validator_1.CommonValidator {
    getAllPossibleInterpretations() {
        const { interpretations = [], options } = this.props;
        const out = interpretations.slice();
        for (const option of Object.values(options)) {
            out.push(...option.getAllPossibleInterpretations());
        }
        return out;
    }
    getAllPossibleTags() {
        const { tags = [], options } = this.props;
        const out = tags.slice();
        for (const option of Object.values(options)) {
            out.push(...option.getAllPossibleTags());
        }
        return out;
    }
    merge(props) {
        return new MultiChoiceValidator({ ...this.props, ...props });
    }
    options(options) {
        return this.merge({ options });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateType, this.validateOptions]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (Array.isArray(ctx.value)) {
            return next();
        }
        ctx.addError({ type: "array" });
    };
    validateOptions = async ({ ctx, next }) => {
        let foundAllOptions = true;
        for (const value of ctx.value) {
            let foundOption = false;
            for (const option of this.props.options) {
                if (option.getValue() === value) {
                    const tempCtx = ctx.merge({ path: [], value });
                    tempCtx.addMessageWithValue(option.getPropsToLog());
                    ctx.mergeLogItems(tempCtx);
                    foundOption = true;
                    break;
                }
            }
            foundAllOptions = foundAllOptions && foundOption;
        }
        if (foundAllOptions) {
            return next();
        }
        ctx.addError({ values: this.getValues() });
    };
    getPropsToLog() {
        const { options: _, ...props } = super.getPropsToLog();
        return { ...props, values: this.getValues() };
    }
    isEmptyValue(value) {
        return value === undefined || value === null;
    }
    getValues() {
        return this.props.options.map(option => option.getValue());
    }
}
exports.MultiChoiceValidator = MultiChoiceValidator;
class MultiChoiceItem {
    props;
    constructor(props) {
        this.props = props;
    }
    getAllPossibleInterpretations() {
        return this.props.interpretations || [];
    }
    getAllPossibleTags() {
        return this.props.tags || [];
    }
    getPropsToLog() {
        const { value: _, ...props } = this.props;
        return { ...props };
    }
    getValue() {
        return this.props.value;
    }
    interpretation(interpretation) {
        const { interpretations = [], ...props } = this.props;
        return new MultiChoiceItem({
            ...props,
            interpretations: [...interpretations, interpretation]
        });
    }
    tag(tag) {
        const { tags = [], ...props } = this.props;
        return new MultiChoiceItem({ ...props, tags: [...tags, tag] });
    }
}
exports.MultiChoiceItem = MultiChoiceItem;
